import { type TEventParams } from './buildParams'

// Sent verbatim when a deploy did not stamp the version. Together with the null state below it keeps
// three cases apart in the data: no params at all (the event predates the release being known),
// `unset` (the deploy did not stamp it) and a real build id.
const UNSET_RELEASE = 'unset'

const RELEASE_KEYS = ['frontend', 'frontend_release_version']

// Built once at boot: the values change only between deploys, the arrays ride every single event.
let releaseParams: TEventParams | null = null
let releaseVersion = ''

export const setAnalyticsRelease = (next?: { frontend?: string }) => {
    releaseVersion = next?.frontend || UNSET_RELEASE

    releaseParams = {
        params__key: RELEASE_KEYS,
        params__value: [0, 0],
        params__str_value: ['react', releaseVersion],
    }
}

export const getReleaseParams = (): TEventParams | null => releaseParams

export const getReleaseVersion = (): string => releaseVersion
